<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>


<div mat-dialog-title>
	<div class="header">
	  <div class="left-head">
		<div class="back_btn" (click)="closeModal()">
		  <img style=" width: 17px;" class="back_btn_img" src="../../../../../assets/images/back_button1.svg" alt="">
		</div>
		<h4 style=" font-size: 14px;
		font-weight: 600;     margin-bottom: 0px;">Learning Centre</h4>
	  </div>
	  <div class="right-head">
		<mat-icon (click)="closeModal()">close</mat-icon>
	  </div>
	</div>

	<!-- <div class="heading_main">
	  <span>C.A.R.E<span style="font-family: 'ArgueFont' !important;" class="tm">™</span>
		MINI’S</span>
	</div> -->

  </div>
  <mat-dialog-content>
	<div id="category-selected-header">
	  <!-- <div class="header">
		<div class="back_btn" (click)="closeModal()">
		  <img style=" width: 17px;" class="back_btn_img" src="../../../../../assets/images/back_button1.svg" alt="">
		</div>
		<h4 style=" font-size: 14px;
		font-weight: 600;     margin-bottom: 0px;">Learning Center</h4>
	  </div> -->

	  <div class="heading_main">
		<span>C.A.R.E<span style="font-family: 'ArgueFont' !important;" class="tm">™</span>
		  MINI’S</span>
	  </div>

	  <!-- <span (click)="closeModal()" class="cross">x</span> -->

	  <div class="rounds">

		<div class="round_headings" *ngIf="clips.length >= 1">
		  <ng-container *ngFor="let heading of clips; let i = index">
			<div [ngClass]="{'one': i==0, 'two': i==1, 'three': i==2}" class="round"
			  (click)="selecteRound(heading.name, i)">
			  <span [ngClass]="{'highlight': selectedRound == heading.name.trim()}" class="head">{{heading.name}}</span>
			  <span class="badge" [ngClass]="{'class': getBackgroundColor(heading.status) == '#8BEFD1'}"
				[ngStyle]="{'background-color':getBackgroundColor(heading.status)}">{{heading.status}}</span>
			  <div class="prog_details">
				<div class="prog_name">{{getStatus(i)}}
				  <div class="progress_percentage">
					<!-- {{heading.miniClipVideosProgress ? (heading.miniClipVideosProgress * 100) / heading.totalDurationClips : 0 }}% -->
					{{getProgressPercentage(heading)}}%
				  </div>
				</div>
				<div class="complete progress">
				  <div role="progressbar" [ngClass]="{'purpleProgress': getProgressPercentage(heading) == 100}"
					class="progress-bar"
					style.width="{{ heading.miniClipVideosProgress ? getProgressPercentage(heading) : 0 }}%"
					aria-valuenow="course.progressCompleted" aria-valuemin="0" aria-valuemax="100">
				  </div>
				</div>
			  </div>
			</div>
		  </ng-container>

		</div>


		<div class="roundOne" *ngIf="clips[activeIndex] && selectedRound == clips[activeIndex].name">

		  <div class="videos">
			<!-- <ng-container *ngFor="let clip of clips"> -->
			<div class="video_card" *ngFor="let item of clips[activeIndex].miniClipData; let i = index;">
			  <img class="coverImage" (click)="openVideoModal(clips, i)" [src]="item.imageUrl" alt="Cover Image">
			  <video oncontextmenu="return false;" (loadedmetadata)="onVideoMetadataLoaded($event, item)" width="320" height="240"
				(click)="openVideoModal(clips, i)">
				<source [src]="item.videoUrl" type="video/mp4">
				<source [src]="item.videoUrl" type="video/ogg">
			  </video>
			  <div (click)="openVideoModal(clips, i)" class="play">
				<img src="../../../../../assets/images/play_button_icon.svg" alt="">
			  </div>
			  <div class="video_prog">
				<div class="w3-border">
				  <div class="w3-grey"
					[ngClass]="{'purpleProgress': (item.progressTime * 100)/item.totalTime == 100}"
					[ngStyle]="{'height':'4px', 'width': item.progressTime ? (item.progressTime * 100)/item.totalTime +'%' : '0%'}">
				  </div>
				</div>
			  </div>
			</div>



			<!-- </ng-container> -->

		  </div>
		</div>


	  </div>
	</div>
  </mat-dialog-content>